import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import config from '@adc/configment'
import App from 'common/containers/app'
import { initializeAnalytics } from '../common/services/analytics'
import configureStore from '../common/store'

/*
 * Analytics is initialized here so GTM can get started sooner
 * The init call is kept in our usual app/analytics location
 * This call will check if each analytics script has already loaded
 */
const initialState = window.INITIAL_STATE.shellState || window.INITIAL_STATE

initializeAnalytics(initialState)

const store = configureStore(initialState)

hydrateRoot(
  window.ROOT_DOM_MOUNT,
  <Provider store={store}>
    <BrowserRouter basename={config.get('URL_BASE_PREFIX')}>
      <App />
    </BrowserRouter>
  </Provider>
)
